import React from 'react';

import { useLocation } from 'react-router-dom';

import GA4React from 'ga-4-react';

import { useGoogleKeysProviderContext } from '@common/react/components/google/GoogleKeysProvider/GoogleKeysProvider';

const GoogleAnalytics: React.FC<{ id?: string }> = (props) => {
	const ga4Ref = React.useRef<any>(null);
	const location = useLocation();
	const {
		id = useGoogleKeysProviderContext()?.state?.analyticsId,
	} = props;

	React.useEffect(() => {
		if (process.env.NODE_ENV === 'production' && id) {
			const ga4react = new GA4React(id);

			ga4react.initialize().then((ga4) => {
				ga4.pageview(window.location.pathname + window.location.search);
				ga4Ref.current = ga4react;
			}, console.error);
		}
	}, []);

	React.useEffect(() => {
		if (id && ga4Ref.current && GA4React.isInitialized()) {
			ga4Ref.current.pageview(location.pathname + location.search);
			ga4Ref.current.gtag('set', 'page', location.pathname);
		}
	}, [location]);

	return <></>;
};

export default GoogleAnalytics;
